const t = "_tag_1b3zi_1", a = "_disabled_1b3zi_5", o = "_stroke_1b3zi_10", _ = "_active_1b3zi_14", n = "_closeContainer_1b3zi_24", r = "_gray_1b3zi_37", e = "_tagButton_1b3zi_61", s = "_tagCount_1b3zi_70", c = "_grayTagCount_1b3zi_76", i = "_strokeTagCount_1b3zi_80", g = "_overrideAvatar_1b3zi_85", b = "_cursor_1b3zi_89", u = "_activeState_1b3zi_119", z = "_backgroundTag_1b3zi_137", d = {
  tag: t,
  disabled: a,
  stroke: o,
  active: _,
  closeContainer: n,
  gray: r,
  tagButton: e,
  tagCount: s,
  grayTagCount: c,
  strokeTagCount: i,
  overrideAvatar: g,
  cursor: b,
  activeState: u,
  backgroundTag: z
};
export {
  _ as active,
  u as activeState,
  z as backgroundTag,
  n as closeContainer,
  b as cursor,
  d as default,
  a as disabled,
  r as gray,
  c as grayTagCount,
  g as overrideAvatar,
  o as stroke,
  i as strokeTagCount,
  t as tag,
  e as tagButton,
  s as tagCount
};
//# sourceMappingURL=Tag.module.scss.js.map
